module.exports = {
  getKeyBinding: require('./getKeyBinding'),
  hasSelectionInBlock: require('./hasSelectionInBlock'),
  handleKeyCommand: require('./handleKeyCommand'),
  handleReturn: require('./handleReturn'),
  onTab: require('./onTab')
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/draft-js-code/lib/index.js
// module id = 386
// module chunks = 0